import { ReactNode } from 'react';

import { Icon } from 'components/Icon/Icon';
import { Tooltip } from 'components/Tooltip/Tooltip';

import { Container, IconContainer, StarContainer } from './StarRating.styled';

const TOOLTIP_TEXT = [
  getText('Dislike it'),
  getText('Could be better'),
  getText('Just okay'),
  getText('Like it!'),
  getText('Love it!'),
];

function TooltipContainer({
  children,
  disableTooltip,
  index,
}: {
  children: ReactNode;
  disableTooltip: boolean;
  index: number;
}) {
  if (disableTooltip) {
    return <div>{children}</div>;
  }
  return (
    <Tooltip variant="filled" content={TOOLTIP_TEXT[index]}>
      {children}
    </Tooltip>
  );
}

type Props = {
  className?: string;
  disabled?: boolean;
  disableTooltip?: boolean;
  iconSize?: number;
  qaIdPrefix: string;
  rating: number | null;
  setRating?: (rating: number) => void;
};

export function StarRating({
  className,
  disabled,
  disableTooltip,
  iconSize,
  qaIdPrefix,
  rating,
  setRating,
}: Props) {
  return (
    <Container
      className={className}
      role="radiogroup"
      data-qa-id={`${qaIdPrefix}-container`}
    >
      {[...Array(5).keys()].map((i) => (
        <StarContainer
          key={i}
          aria-label={disableTooltip ? String(i + 1) : TOOLTIP_TEXT[i]}
          aria-checked={rating === i + 1 ? 'true' : 'false'}
          data-qa-id={`${qaIdPrefix}-${i + 1}`}
          data-qa-index={i + 1}
          $disabled={disabled}
          $filled={rating ? i < rating : false}
          onClick={() => !disabled && setRating && setRating(i + 1)}
          role={disabled ? 'none' : 'radio'}
        >
          <TooltipContainer
            disableTooltip={Boolean(disabled || disableTooltip)}
            index={i}
          >
            <IconContainer>
              <div className="star-filled">
                <Icon name="star-filled" size={iconSize || 27} />
              </div>
              <div className="star-outline">
                <Icon name="star-outline" size={iconSize || 27} />
              </div>
            </IconContainer>
          </TooltipContainer>
        </StarContainer>
      ))}
    </Container>
  );
}
